import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import { EditorOptions } from 'src/app/interfaces/editor-options.interface';

@Component({
  selector: 'app-monaco-code-editor',
  imports: [CommonModule, FormsModule, MonacoEditorModule],
  templateUrl: './monaco-code-editor.component.html',
  styleUrl: './monaco-code-editor.component.scss'
})
export class MonacoCodeEditorComponent {
  @Input() code: string = '';
  @Input() editorOptions: EditorOptions | undefined;
  @Input() editorHeight: number = 400;
  @Output() codeChange = new EventEmitter<string>();

  onCodeChange(newCode: string): void {
    this.codeChange.emit(newCode);
  }
  
}
